<template>
    <div>
        <VueECharts :option="reactiveChartOptions" style="width: 100%; height: 300px" class="chart"></VueECharts>
    </div>
</template>

<script setup>
import { ref, watch, computed } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n({ useScope: 'global' });

const props = defineProps({
    data: {
        type: Object,
        default: {},
    },
});

const generateChartOptions = (data) => {
    return {
        color: ['#5470c6', '#34C759', '#FF4747'],
        legend: {
            data: [
                {
                    name: computed(() => t('chart.total')),
                    textStyle: {
                        color: '#5470c6',
                    },
                },
                {
                    name: computed(() => t('chart.successful')),
                    textStyle: {
                        color: '#34C759',
                    },
                },
                {
                    name: computed(() => t('chart.blocked')),
                    textStyle: {
                        color: '#FF4747',
                    },
                },
            ],
            icon: 'circle',

            emphasis: {
                selectorLabel: {
                    show: true,
                },
            },
        },
        grid: {
            left: '0.2%',
            right: '0.2%',
            bottom: '0.2%',
            containLabel: true,
        },
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                animation: false,
            },
        },
        toolbox: {
            feature: {
                magicType: { show: true, type: ['line', 'bar'] },
                saveAsImage: {},
            },
        },
        xAxis: {
            type: 'category',
            boundaryGap: false,
            data: data?.xAxis,
        },
        yAxis: {
            type: 'value',
            splitLine: {
                show: false,
            },
        },
        dataZoom: [
            {
                show: true,
                realtime: true,
            },
        ],
        series: [
            {
                data: data?.total,
                type: 'line',
                symbol: 'none',
                smooth: true,
                lineStyle: {
                    width: 2,
                    type: 'dashed',
                },
                itemStyle: {
                    borderRadius: 8,
                },
                name: computed(() => t('chart.total')),
            },
            {
                data: data?.finished,
                type: 'line',
                smooth: true,
                symbol: 'none',
                name: computed(() => t('chart.successful')),
                itemStyle: {
                    borderRadius: 8,
                },
            },
            {
                data: data?.blocked,
                type: 'line',
                symbol: 'none',
                smooth: true,
                lineStyle: {
                    width: 2,
                    type: 'dashed',
                },
                itemStyle: {
                    borderRadius: 8,
                },
                name: computed(() => t('chart.blocked')),
            },
        ],
    };
};

const reactiveChartOptions = ref(generateChartOptions(props.data));

watch(
    () => props.data,
    (newData) => {
        reactiveChartOptions.value = generateChartOptions(newData);
    }
);
</script>

<style scoped>
.chart {
}
</style>
